import React, { useState, useEffect, useRef } from 'react';
import { Container, Typography, Select, FormControl } from '@material-ui/core';
import { displayedDueDate } from '../../Quotes/components/QuoteFields';
import { makeStyles } from '@material-ui/core/styles';

import { Prompt } from 'react-router-dom';
import ContentWrapper from 'components/ContentWrapper';
import { useForm, Controller, useFieldArray } from "react-hook-form";

import Commercials from './Commercials';
import Engineering from './Engineering';
import Production from './Production';

import ModelDuty from './ModelDuty';

import Table, { orderDueFields } from './Table';
import Motor from './Motor';
import Impeller from './Impeller';
import Liners from './Liners';
import Hub from './Hub';
import HubBush from './HubBush';

import FanPulley from './FanPulley';
import MotorPulley from './MotorPulley';
import Belts from './Belts';
import BeltGuard from './BeltGuard';
import SlideRails from './SlideRails';

import Balancing from './Balancing';
import Shaft from './Shaft';
import CoolingFin from './CoolingFin';
import ShaftGuard from './ShaftGuard';
import { BearingsDE, BearingsNDE } from './Bearings';
import ShaftSeal from './ShaftSeal';
import { ShaftSealElementA, ShaftSealElementB } from './ShaftSealElement';
import Couplings from './Couplings';
import CouplingGuard from './CouplingGuard';
import Case from './Case';
import InletCone from './InletCone';
import Pedestal from './Pedestal';
import Base from './Base';
import BaseMount from './BaseMount';

import InletDamper from './InletDamper';
import InletBox from './InletBox';
import InletSilencer from './InletSilencer';
import {InletSilencerTransition, OutletSilencerTransition} from './SilencerTransition';
import InletFlexible from './InletFlexible';
import InletVanes from './InletVanes';
import Evase from './Evase';

import OutletDamper from './OutletDamper';
import OutletSilencer from './OutletSilencer';
import OutletFlexible from './OutletFlexible';

import Internal from './Internal';
import External from './External';
import LagClad from './LagClad';

import OtherOptions from './OtherOptions';

import NDT from './NDT';
import QA from './QA';
import Delivery from './Delivery';

import { Button, Grid } from '@material-ui/core';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Modal from '@material-ui/core/Modal';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import ReactHookTextField from 'components/ReactHookTextField';

import makePost from 'helpers/makePost';
import { useDispatch } from 'store';
import { addFeedback } from 'actions';

import * as JsonDiffPatch from 'jsondiffpatch';
import 'jsondiffpatch/dist/formatters-styles/html.css';

import { pdf } from '@react-pdf/renderer';
import JobSheetPDF from './JobSheetPDF';
import WarehousePDF from './WarehousePDF';
import PaintPDF from './PaintPDF';

import { saveAs } from 'file-saver';
import { axiosInstance } from 'App';

import Files from 'components/Files';

import TableMain from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import fanSizePlusMinus from 'helpers/fanSizePlusMinus';

import { useAuth } from 'providers/auth';

import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        margin: '20px',
        padding: '20px',
    },
    list: {
        width: 250,
    },
    selectLabel: {
        backgroundColor: 'white',
        paddingLeft: 2,
        paddingRight: 2
    },
    listItem: {
        whiteSpace: "normal",
    },
    listItemExtra: {
        color: theme.palette.grey[700],
        lineHeight: theme.spacing(3) + 'px',
        marginBottom: theme.spacing(2),
    },
    disabledInput: {
        marginBottom: theme.spacing(2),
        '& .MuiInputBase-input': {
            color: theme.palette.primary.main,
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none'
        }
    },
    caption: {
        color: 'black !important',
        padding: '0 0 6px 0 !important',
        captionSide: 'top !important',
        textAlign: 'center !important',
    },
    head: {
        height: 40,
        paddingTop: 0,
        paddingBottom: 0,
        textAlign: "center",
        fontWeight: 900,
    },

    root2: {
        width: "100%",
        marginTop: theme.spacing(3),
        overflowX: "auto"
    },
    table: {
        minWidth: 300,
        border: '1px solid #dcdddf',
        borderRadius: '5px',
        padding: '12px',
        borderCollapse: 'initial'
    },
    selectTableCell: {
        width: 20,
        padding: '3px 6px'
    },
    tableCell: {
        width: 50,
        height: 40,
        textAlign: "center",
        padding: '3px 6px',
        borderLeft: '1px solid #dcdddf',
        borderRight: '1px solid #dcdddf',
        '& .MuiOutlinedInput-input' : {
            paddingLeft: 0,
            paddingRight: 0
        }
    },
    input: {
        width: '100%',
        height: 40
    },
    heading: {
        fontSize: '1.6em',
        fontWeight: 'bold',
        lineHeight: '1.235',
        flexBasis: '20%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: '1.2em',
        fontWeight: '600',
        lineHeight: '1.6em',
    },
    secondaryRedHeading: {
        color: 'red',
        fontSize: '1.2em',
        lineHeight: '1.6em',
    },
    select: {
        background: "#ffffff",
    },
    paper: {
        position: 'absolute',
        width: 400,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),

        top: `${50}%`,
        left: `${50}%`,
        transform: `translate(-${50}%, -${50}%)`,
    },
    conflictChanges: {
        '& .jsondiffpatch-modified .jsondiffpatch-left-value pre': {
            background: '#b3e5fc',
            textDecoration: 'none'
        },
        '& .jsondiffpatch-modified .jsondiffpatch-right-value pre': {
            background: '#f3e5f5'
        }
    }


}), { index: 1 });

const nullableFields = [
    //AirEngPlatform/API/Dto/CustomFan/Attributes/CustomFanAttributes.cs
    "CaseQty", "CaseOrderDue", "InletConeQty", "InletConeOrderDate", "InletConeOrderDue", "PedestalQty", "PedestalOrderDate", "PedestalOrderDue", "FanSellPrice", "FanEstimatedCost", "FanSellPriceOptions", "FanEstimatedCostOptions", "FanQty", "FanSizePlusMinus", "FanPercentageWidth", "FanPercentageSize", "FanVolume", "FanVolumeLPerS", "FanInletPressure", "FanInletPressurePa", "FanDischargePressure", "FanDischargePressurePa", "FanRpm", "FanDesignTempC", "FanDutyKW", "FanDutyDensity", "FanElevationMASL", "MotorQty", "MotorKW", "MotorSpeed", "MotorOrderDate", "MotorOrderDue", "ImpellerDiameter", "ImpellerClass", "ImpellerQty", "ImpellerOrderDate", "ImpellerOrderDue", "LinerQty", "LinerBladesPercentage", "LinerOrderDate", "LinerOrderDue", "HubQty", "HubOrderDate", "HubOrderDue", "HubBushQty", "HubBushOrderDate", "HubBushOrderDue", "FanPulleyQty", "FanPulleyOrderDate", "FanPulleyOrderDue", "DriveMotorPulleyQty", "DriveMotorPulleyOrderDate", "DriveMotorPulleyOrderDue", "DriveBeltQty", "DriveBeltOrderDate", "DriveBeltOrderDue", "DriveBeltGuardQty", "DriveBeltGuardOrderDate", "DriveBeltGuardOrderDue", "DriveSlideRailsQty", "DriveSlideRailsOrderDate", "DriveSlideRailsOrderDue", "BalanceQty", "BalanceOrderDate", "BalanceOrderDue", "ShaftQty", "ShaftDEDia", "ShaftNDEDia", "ShaftDia", "ShaftOrderDate", "ShaftOrderDue", "CoolingFinQty", "CoolingFinOrderDate", "CoolingFinOrderDue", "ShaftGuardQty", "ShaftGuardOrderDate", "ShaftGuardOrderDue", "BearingDEQty", "BearingDEOrderDate", "BearingDEOrderDue", "BearingNDEQty", "BearingNDEOrderDate", "BearingNDEOrderDue", "ShaftSealQty", "ShaftSealThickness", "ShaftSealOrderDate", "ShaftSealOrderDue", "ShaftSealElementAQty", "ShaftSealElementAOrderDate", "ShaftSealElementAOrderDue", "ShaftSealElementBQty", "ShaftSealElementBOrderDate", "ShaftSealElementBOrderDue", "CouplingQty", "CouplingOrderDate", "CouplingOrderDue", "CouplingGuardQty", "CouplingGuardOrderDate", "CouplingGuardOrderDue", "BaseQty", "BaseOrderDate", "BaseOrderDue", "BaseMountOrderDate", "BaseMountOrderDue", "InletDamperQty", "InletDamperNoBlades", "InletDamperOrderDate", "InletDamperOrderDue", "InletBoxQty", "InletBoxOrderDate", "InletBoxOrderDue", "InletSilencerQty", "InletSilencerOrderDate", "InletSilencerOrderDue", "InletSilencerTransitionQty", "InletSilencerTransitionOrderDate", "InletSilencerTransitionOrderDue", "InletFlexibleQty", "InletFlexibleOrderDate", "InletFlexibleOrderDue", "InletVanesQty", "InletVanesOrderDate", "InletVanesOrderDue", "EvaseQty", "EvaseOrderDue", "OutletDamperQty", "OutletDamperNoBlades", "OutletDamperOrderDate", "OutletDamperOrderDue", "OutletSilencerQty", "OutletSilencerOrderDate", "OutletSilencerOrderDue", "OutletSilencerTransitionQty", "OutletSilencerTransitionOrderDate", "OutletSilencerTransitionOrderDue", "OutletFlexibleQty", "OutletFlexibleOrderDate", "OutletFlexibleOrderDue", "InternalCoatingQty", "InternalCoatingOrderDate", "InternalCoatingOrderDue", "ExternalCoatingQty", "ExternalCoatingOrderDate", "ExternalCoatingOrderDue", "LagCladQty", "FinishingLagOrderDate", "FinishingLagOrderDue", "CommercialsEngQuoted", "CommercialsFabQuoted", "CommercialsFitQuoted",
    //AirEngPlatform/API/Dto/Job/Attributes/JobAttributes.cs
    "CommercialsOrderDate", "CommercialsDueDate", "CommercialsRevisedDueDate", "CommercialsWarrantyPeriod", "CommercialsWarrantyFrom", "CommercialsEngAllowed", "CommercialsEngActual", "CommercialsFabAllowed", "CommercialsFabActual", "CommercialsFitAllowed", "CommercialsFitActual", "EngineeringExpectedStart", "ProductionFabExpectedStart", "ProductionFitExpectedStart", "ProductionAllocated", "QaItpPerson", "QaCompletionDate", "DeliveryDateBooked", "DeliveryDateSent",
]

const numFields = [
    //AirEngPlatform/API/Dto/CustomFan/Attributes/CustomFanAttributes.cs - int
    "CaseQty", "InletConeQty", "PedestalQty", "MotorQty", "ImpellerDiameter", "ImpellerQty", "LinerQty", "HubQty", "HubBushQty", "FanPulleyQty", "DriveMotorPulleyQty", "DriveBeltQty", "DriveBeltGuardQty", "DriveSlideRailsQty", "BalanceQty", "ShaftQty", "CoolingFinQty", "ShaftGuardQty", "BearingDEQty", "BearingNDEQty", "ShaftSealQty", "ShaftSealElementAQty", "ShaftSealElementBQty", "CouplingQty", "CouplingGuardQty", "BaseQty", "InletDamperQty", "InletDamperNoBlades", "InletBoxQty", "InletSilencerQty", "InletSilencerTransitionQty", "InletFlexibleQty", "InletVanesQty", "EvaseQty", "OutletDamperQty", "OutletDamperNoBlades", "OutletSilencerQty", "OutletSilencerTransitionQty", "OutletFlexibleQty", "InternalCoatingQty", "ExternalCoatingQty", "LagCladQty", 
    //AirEngPlatform/API/Dto/CustomFan/Attributes/CustomFanAttributes.cs - float
    "FanSellPrice", "FanEstimatedCost", "FanSellPriceOptions", "FanEstimatedCostOptions", "FanSizePlusMinus", "FanPercentageWidth", "FanPercentageSize", "FanVolume", "FanVolumeLPerS", "FanInletPressure", "FanInletPressurePa", "FanDischargePressure", "FanDischargePressurePa", "FanDesignTempC", "FanDutyKW", "FanDutyDensity", "FanElevationMASL", "LinerBladesPercentage", "ShaftDEDia", "ShaftNDEDia", "ShaftDia", "ShaftSealThickness", "CommercialsEngQuoted", "CommercialsFabQuoted", "CommercialsFitQuoted", "CommercialsQaQuoted", 
    //AirEngPlatform/API/Dto/Job/Attributes/JobAttributes.cs
    "CommercialsWarrantyPeriod", "CommercialsEngAllowed", "CommercialsEngActual", "CommercialsFabAllowed", "CommercialsFabActual", "CommercialsFitAllowed", "CommercialsFitActual", "CommercialsQaAllowed", "CommercialsQaActual",
]

const Form = ({ jobData, quoteData, clientData, changesData, jobStatusList, jobStateList, projectDraftspersonList, categories, formatData }) => {
    const { userAttr } = useAuth();

    const dispatch = useDispatch()
    const classes = useStyles();

    const [showEdit, setShowEdit] = useState(false);
    const [statusOpen, setStatusOpen] = useState(false);
    const [forceConfirmOpen, setForceConfirmOpen] = useState(false);
    const [pendingDiff, setPendingDiff] = useState(null);
    const savedSnapshotRef = useRef({ attributes: jobData.attributes, lineItems: jobData.lineItems || [], jobStatusID: jobData.jobStatusID });

    const [openDialog, setOpenDialog] = useState(false);
    const [myChanges, setMyChanges] = useState(null);
    const [theirData, setTheirData] = useState(null);
    const [theirChanges, setTheirChanges] = useState(null);
    const [mergeData, setMergeData] = useState(null);
    const [conflictChanges, setConflictChanges] = useState(null);

    const { handleSubmit, watch, control, setError, getValues, setValue, reset, formState: { isDirty } } = useForm({
        mode: "onChange",
        resolver: yupResolver(Yup.object({
            attributes: Yup.object({
                ...numFields.reduce((acc, field) => {
                    const f = field[0].toLowerCase() + field.slice(1)
                    return {
                        ...acc,
                        [f]: Yup.number().nullable().transform((_, value) => {
                            return value === "" || value === null ? null : Number(value);
                          }).typeError(f + ' must be only a number'),
                    }
                }, {}), 
            })
        })),
        defaultValues: {
            ...formatData(jobData),
            updatedAt: jobData.updatedAt
        }
    });

    const { fields, append, remove } = useFieldArray({
        control,
        name: "lineItems"
    });

    const qaItp = watch('attributes.qaItp');
    const deliveryPacking = watch('attributes.deliveryPacking');

    const commercialsDueDate = watch('attributes.commercialsDueDate');
    const commercialsRevisedDueDate = watch('attributes.commercialsRevisedDueDate');
    const watchedOrderDues = watch(orderDueFields);
    const watchedLineItems = watch('lineItems');

    const effectiveDueDate = (commercialsDueDate && commercialsRevisedDueDate)
        ? (commercialsDueDate >= commercialsRevisedDueDate ? commercialsDueDate : commercialsRevisedDueDate)
        : (commercialsDueDate || commercialsRevisedDueDate);
    const lineItemOrderDues = (watchedLineItems || []).map(item => item?.orderDue);
    const anyOverdue = !!effectiveDueDate && [...watchedOrderDues, ...lineItemOrderDues].some(due => due && due > effectiveDueDate);
    const dueDateOverdue = anyOverdue && !!commercialsDueDate && (!commercialsRevisedDueDate || commercialsDueDate >= commercialsRevisedDueDate);
    const revisedDueDateOverdue = anyOverdue && !!commercialsRevisedDueDate && (!commercialsDueDate || commercialsRevisedDueDate > commercialsDueDate);

    const prevPackingRef = useRef(watch('attributes.deliveryPacking') || null);

    useEffect(() => {
        const prev = prevPackingRef.current;
        const current = deliveryPacking || null;
        if (!prev && current) {
            append({
                qty: 1,
                description: current,
                drawing: null,
                stock: null,
                supplier: null,
                orderDate: null,
                orderDue: null,
                orderReceived: null,
                notes: null,
            });
        }
        prevPackingRef.current = current;
    }, [deliveryPacking]);

    useEffect(() => {
        const handler = (e) => {
            if (isDirty) {
                e.preventDefault();
                e.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', handler);
        return () => window.removeEventListener('beforeunload', handler);
    }, [isDirty]);

    const forceConfirmStatuses = ['Procurement', 'Manufacturing'];

    const handleSaveClick = () => {
        const currentStatusID = getValues('jobStatusID');
        const currentLabel = jobStatusList.find(s => String(s.id) === String(currentStatusID))?.label;
        const isForceConfirm = forceConfirmStatuses.includes(currentLabel);
        const isPurchasing = userAttr.roles.includes('Purchasing');
        if (isForceConfirm && !isPurchasing) {
            const current = getValues();
            const diff = JsonDiffPatch.diff(
                savedSnapshotRef.current,
                { attributes: current.attributes, lineItems: current.lineItems || [], jobStatusID: current.jobStatusID }
            );
            setPendingDiff(diff || null);
            setForceConfirmOpen(true);
        } else {
            handleSubmit(onSubmit)();
        }
    };

    const onSubmit = async (data) => {
        try {
            const response = await makePost({
                url: `/jobs/${jobData.id}/customfans`,
                data: {
                    ...data,
                    attributes: {
                        ...data.attributes,
                        fanQty: data.attributes.fanQty === "" ? null : data.attributes.fanQty,
                        ...categories.reduce((acc, field) => {
                            const orderDate = `${field}OrderDate`;
                            const orderDue = `${field}OrderDue`;
                            const qty = `${field}Qty`;
                            return {
                                ...acc,
                                [orderDate]: data.attributes[orderDate] === "" ? null : data.attributes[orderDate],
                                [orderDue]: data.attributes[orderDue] === "" ? null : data.attributes[orderDue],
                                [qty]: data.attributes[qty] === "" ? null : data.attributes[qty],
                            }
                        }, {}),
                        commercialsInvoiceTo: { ...data.attributes.commercialsInvoiceTo.id === null ? {} : data.attributes.commercialsInvoiceTo },
                        commercialsDeliverTo: { ...data.attributes.commercialsDeliverTo.id === null ? {} : data.attributes.commercialsDeliverTo },
                        ...nullableFields.reduce((acc, field) => {
                            const f = field[0].toLowerCase() + field.slice(1)
                            return {
                                ...acc,
                                [f]: data.attributes[f] === "" ? null : data.attributes[f],
                            }
                        }, {}),
                    },
                    lineItems: data.lineItems.length ? data.lineItems.map((field, i) => {
                        return {
                            ...field,
                            orderDate: field.orderDate === "" ? null : field.orderDate,
                            orderDue: field.orderDue === "" ? null : field.orderDue,
                        }
                    }) : [],
                },
            });

            if (response.status === 200) {
                reset({ ...getValues(), updatedAt: response.data.updatedAt });
                savedSnapshotRef.current = { attributes: data.attributes, lineItems: data.lineItems || [], jobStatusID: data.jobStatusID };
            }

            setStatusOpen(false);
            setOrigJobStatus({ jobStatusID: data.jobStatusID, jobStatusNotice: data.jobStatusNotice })
            dispatch(addFeedback('Job saved', 'success'));
            return response.status === 200;
        } catch (error) {
            const errResp = error.response;
            if (errResp.status === 422) {
                const errData = errResp.data.data;
                setTheirData(errData)

                const mC = JsonDiffPatch.diff({
                    attributes: jobData.attributes,
                    combinedCost: jobData.combinedCost,
                    combinedPrice: jobData.combinedPrice,
                    jobStatusID: jobData.jobStatusID,
                    lineItems: jobData.lineItems
                }, {
                    attributes: data.attributes,
                    combinedCost: data.combinedCost,
                    combinedPrice: data.combinedPrice,
                    jobStatusID: data.jobStatusID,
                    lineItems: data.lineItems
                });

                setMyChanges(mC)

                const tC = JsonDiffPatch.diff({
                    attributes: jobData.attributes,
                    combinedCost: jobData.combinedCost,
                    combinedPrice: jobData.combinedPrice,
                    jobStatusID: jobData.jobStatusID,
                    lineItems: jobData.lineItems
                }, {
                    ...formatData(errData)
                });

                setTheirChanges(tC)

                const difference = (object, other, nestedKey) => {
                    var diff = {};

                    for (const key of Object.keys(object)) {
                        if ((!Array.isArray(object[key]) && typeof object[key] === 'object') && (!Array.isArray(other[key]) && typeof other[key] === 'object') && object[key] && other[key]) {
                            diff[key] = difference(object[key], other[key]);
                        } else if (object[key] !== undefined && other[key] !== undefined) {
                            diff[key] = [object[key][1], other[key][1]];
                        }
                    }

                    return Object.keys(diff).length === 0 ? null : diff;
                }

                const conflictMap = difference(tC, mC);

                if ((conflictMap.attributes && Object.keys(conflictMap.attributes).length === 0) || conflictMap.attributes === null) {
                    delete conflictMap.attributes
                }

                if (conflictMap.lineItems) {
                    delete conflictMap.lineItems._t
                }

                if (conflictMap.lineItems && Object.keys(conflictMap.lineItems).length === 0) {
                    delete conflictMap.lineItems
                }

                if (Object.keys(conflictMap).length > 0) {
                    setConflictChanges(conflictMap)
                    const clone = JSON.parse(JSON.stringify(mC));

                    const removeDelta = (obj, nestedKey) => {
                        for (const key of Object.keys(obj)) {
                            if (nestedKey === undefined) {
                                nestedKey = key;
                            } else {
                                nestedKey = nestedKey + '.' + key
                            }

                            if ((!Array.isArray(obj[key]) && typeof obj[key] === 'object')) {
                                removeDelta(obj[key], nestedKey)
                            } else {
                                let keys = nestedKey.split('.');
                                let prop = keys.pop();
                                let parent = keys.reduce((obj, key) => obj[key], clone);

                                delete parent[prop];
                            }
                        }
                    }

                    removeDelta(conflictMap);

                    if ((clone.attributes && Object.keys(clone.attributes).length === 0) || clone.attributes === null) {
                        delete clone.attributes
                    }

                    if (clone.lineItems) {
                        delete clone.lineItems._t
                    }

                    if (clone.lineItems !== undefined) {
                        if (clone.lineItems && Object.keys(clone.lineItems).length === 0) {
                            delete clone.lineItems
                        } else {
                            for (const key of Object.keys(clone.lineItems)) {
                                if (Object.keys(clone.lineItems[key]).length === 0) {
                                    delete clone.lineItems[key]
                                }
                            }

                            if (clone.lineItems && Object.keys(clone.lineItems).length === 0) {
                                delete clone.lineItems
                            }
                        }
                    }

                    setMergeData(Object.keys(clone).length === 0 ? errData : JsonDiffPatch.patch(errData, clone))
                } else {
                    setMergeData(JsonDiffPatch.patch(errData, mC))
                }

                setOpenDialog(true)
            } else {
                const errData = errResp.data
                
                Object.keys(errData.errors).map((key) => {
                    setError(key.slice(2), errData.errors[key][0]);
                    return null;
                });

                dispatch(addFeedback(errData.title || errData, 'error', errData.errors));
            }
            return false;
        }
    };

    // Save first so the PDF is built from what is on screen, and skip it if the save fails
    const generatePDF = async (PDF, filename) => {
        let saved = false;
        await handleSubmit(async (data) => {
            saved = await onSubmit(data);
        })();
        if (!saved) return;

        const quoteRes = await axiosInstance({ url: `/quotes/${jobData.quoteID}/${jobData.itemID}/${jobData.revision}` });
        const jobRes = await axiosInstance({ url: `/jobs/${jobData.id}/customfans` });

        const blob = await pdf((
            <PDF quoteData={quoteRes.data} jobData={jobRes.data} />
        )).toBlob();

        saveAs(blob, `${filename}-${jobData.id}.pdf`);
    };

    const [expanded, setExpanded] = useState([]);

    const [origJobStatus, setOrigJobStatus] = useState({
        jobStatusID: jobData.jobStatusID,
        jobStatusNotice: jobData.jobStatusNotice
    });

    const handleChange = (panel) => () => {
        if (expanded.includes(panel)) {
            const newExpanded = expanded.filter((item) => item !== panel)
            setExpanded(newExpanded)
        } else {
            setExpanded([...expanded, panel]);
        }
    };

    const handleMerge = () => {
        reset(formatData(mergeData))
        setValue('updatedAt', theirData.updatedAt)
        setOpenDialog(false)
    };

    const handleCancel = () => {
        reset(formatData(theirData))
        setValue('updatedAt', theirData.updatedAt)
        setOpenDialog(false)
    };
    
    return (
        <Container maxWidth={false}>
            <Prompt
                when={isDirty}
                message="You have unsaved changes. Are you sure you want to leave?"
            />
            <Dialog
                open={openDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Oh No!</DialogTitle>
                <DialogContent>

                    <DialogContentText>
                        {conflictChanges !== null ? <>Someone has made changes while you’ve been editing.</> : <>Someone has made changes while you’ve been editing and these conflict with your work</>}
                        Please review the changes below:
                    </DialogContentText>
                    {conflictChanges !== null &&
                        <>
                            <Typography variant="h5">Conflict Changes</Typography>
                            {<div className={classes.conflictChanges} dangerouslySetInnerHTML={{ __html: JsonDiffPatch.formatters.html.format(conflictChanges) }} />}
                            <DialogContentText>
                                This can only be fixed manually after reloading the page.
                            </DialogContentText>
                        </>
                    }
                    {myChanges !== null ?
                        <>
                            <Typography variant="h5">Your Changes</Typography>
                            {<div dangerouslySetInnerHTML={{ __html: JsonDiffPatch.formatters.html.format(myChanges) }} />}
                        </> : ''
                    }
                    {theirChanges !== null ?
                        <>
                            <Typography variant="h5">Updates requiring attention</Typography>
                            <b>Date:</b> {theirData.updatedAt.slice(0, 10)}<br />
                            <b>User:</b> {theirData.updatedUserName}<br />
                            {<div dangerouslySetInnerHTML={{ __html: JsonDiffPatch.formatters.html.format(theirChanges) }} />}
                        </> : ''
                    }
                    <DialogContentText>
                        You can MERGE these changes, review, and then press SAVE to accept.
                        Otherwise press CANCEL to discard your changes and reload.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <>
                        <Button onClick={handleMerge} color="primary" autoFocus>
                            Merge
                        </Button>
                        <Button onClick={handleCancel} color="primary" autoFocus>
                            Cancel
                        </Button>
                    </>
                </DialogActions>
            </Dialog>

            <form onSubmit={handleSubmit(onSubmit)}>
                <br />
                <Grid container justifyContent="space-between">
                    <Grid item>
                        <Typography variant="h1" className={classes.header}>Job Sheet: {jobData.id}</Typography>
                    </Grid>

                    <Grid item>
                        <Typography variant="h1" className={classes.header} style={{ display: 'inline' }}>Status: </Typography>

                        <Controller
                            name='jobStatusID'
                            type={'select'}
                            control={control}
                            render={({ field, fieldState: { error } }) =>
                                <FormControl variant='outlined' className={classes.select}>
                                    <Select
                                        native
                                        {...field}
                                        margin='dense'
                                        onChange={(e) => {
                                            setStatusOpen(true);
                                            const fromLabel = jobStatusList.find(s => String(s.id) === String(origJobStatus.jobStatusID))?.label;
                                            const toLabel = jobStatusList.find(s => String(s.id) === String(e.target.value))?.label;
                                            if (fromLabel === 'Packing' && toLabel === 'Dispatch') {
                                                const missing = (getValues('lineItems') || []).filter(item => item.warehouse && !item.orderReceived);
                                                if (missing.length) {
                                                    const lines = missing.map(item => `${item.description || ''} - ${item.orderDue || ''}`).join('\n');
                                                    setValue('jobStatusNotice', `Missing Warehouse Items:\n${lines}`);
                                                } else {
                                                    setValue('jobStatusNotice', '');
                                                }
                                            } else {
                                                setValue('jobStatusNotice', '');
                                            }
                                            return field.onChange(e.target.value);
                                        }}>
                                        {jobStatusList.map(({ label, id }) => {
                                            return [
                                                <option key={`status-${id}`} value={id}>{label}</option>
                                            ]
                                        })}
                                    </Select>
                                </FormControl>
                            }
                        />

                        <Modal open={statusOpen} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
                            <div className={classes.paper}>
                                <h2 id="simple-modal-title">Status Change</h2>
                                <p id="simple-modal-description">
                                    <ReactHookTextField
                                        name='jobStatusNotice'
                                        type='textarea'
                                        control={control}
                                        label='Note:'
                                        style={{ width: '100%' }}
                                        InputProps={{
                                            multiline: true,
                                            rows: 3
                                        }}
                                    />
                                </p>

                                <Grid container justify="space-between">
                                    <Grid item>
                                        <Button
                                            variant='contained'
                                            color="secondary"
                                            type='submit'
                                            onClick={() => {
                                                handleSubmit(onSubmit)()
                                            }}
                                        >
                                            Confirm
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            variant='contained'
                                            color="secondary"
                                            type='submit'
                                            onClick={() => {
                                                setValue('jobStatusID', origJobStatus.jobStatusID)
                                                setValue('jobStatusNotice', origJobStatus.jobStatusNotice)
                                                setStatusOpen(false)
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>
                                </Grid>

                            </div>
                        </Modal>

                        <Modal open={forceConfirmOpen} aria-labelledby="force-confirm-title" aria-describedby="force-confirm-description">
                            <div className={classes.paper} style={{ maxHeight: '80vh', overflowY: 'auto', width: '600px' }}>
                                <h2 id="force-confirm-title">Confirm Changes</h2>
                                <p id="force-confirm-description">
                                    Please confirm that you wish to make these changes to the job while the status is in <strong>{jobStatusList.find(s => String(s.id) === String(getValues('jobStatusID')))?.label}</strong>. Please notify relevant parties of these changes.
                                </p>
                                <Typography variant="h6" gutterBottom>Pending Changes</Typography>
                                {pendingDiff
                                    ? <div className={classes.conflictChanges} dangerouslySetInnerHTML={{ __html: JsonDiffPatch.formatters.html.format(pendingDiff) }} />
                                    : <Typography variant="body2">No changes detected.</Typography>
                                }
                                <br />
                                <Grid container justify="space-between">
                                    <Grid item>
                                        <Button
                                            variant='contained'
                                            color="secondary"
                                            type='button'
                                            onClick={() => {
                                                setForceConfirmOpen(false);
                                                handleSubmit(onSubmit)();
                                            }}
                                        >
                                            Confirm
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            variant='contained'
                                            type='button'
                                            onClick={() => setForceConfirmOpen(false)}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>
                        </Modal>
                    </Grid>
                </Grid>

                <br />

                <Accordion expanded={expanded.includes('panel1')} onChange={handleChange('panel1')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                    >
                        <Typography className={classes.heading}>Commercials</Typography>
                        {!expanded.includes('panel1') &&
                            <Typography className={classes.secondaryHeading}>
                                Client: {quoteData.clientDetails?.name} | Quote No: {quoteData.quoteID}{quoteData.revision}{quoteData.itemID} | Product Area: {quoteData.productAreaName} | Sales Rep: {quoteData.salesRepName} | Due Date: {displayedDueDate(getValues('attributes.commercialsDueDate'), getValues('attributes.commercialsRevisedDueDate'))}
                            </Typography>
                        }
                    </AccordionSummary>
                    <AccordionDetails style={{ background: '#fff2cc', paddingTop: '20px' }}>
                        <Commercials control={control} jobData={jobData} quoteData={quoteData} clientData={clientData} getValues={getValues} createdAt={jobData.createdAt} watch={watch} setValue={setValue} dueDateOverdue={dueDateOverdue} revisedDueDateOverdue={revisedDueDateOverdue} />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded.includes('panel2')} onChange={handleChange('panel2')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2bh-content"
                        id="panel2bh-header"
                    >
                        <Typography className={classes.heading}>Engineering</Typography>
                        {!expanded.includes('panel2') && <Typography className={classes.secondaryHeading}>Project Draftsperson: {getValues('attributes.engineeringDraftsPerson')} | Expected Start Date: {getValues('attributes.engineeringExpectedStart') && new Date(getValues('attributes.engineeringExpectedStart')).toLocaleDateString("en-AU", { day: '2-digit', month: '2-digit', year: '2-digit' })}</Typography>}
                    </AccordionSummary>
                    <AccordionDetails style={{ background: '#fff2cc', paddingTop: '20px' }}>
                        <Engineering control={control} getValues={getValues} projectDraftspersonList={projectDraftspersonList} />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded.includes('panel3')} onChange={handleChange('panel3')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3bh-content"
                        id="panel3bh-header"
                    >
                        <Typography className={classes.heading}>Production</Typography>
                        {!expanded.includes('panel3') &&
                            <Typography className={classes.secondaryHeading}>
                                Expected Fab Start: {getValues('attributes.productionFabExpectedStart') && new Date(getValues('attributes.productionFabExpectedStart')).toLocaleDateString("en-AU", { day: '2-digit', month: '2-digit', year: '2-digit' })} | Expected Fit Start: {getValues('attributes.productionFitExpectedStart') && new Date(getValues('attributes.productionFitExpectedStart')).toLocaleDateString("en-AU", { day: '2-digit', month: '2-digit', year: '2-digit' })}
                            </Typography>
                        }
                    </AccordionSummary>
                    <AccordionDetails style={{ background: '#fff2cc', paddingTop: '20px' }}>
                        <Production control={control} getValues={getValues} />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded.includes('panel4')} onChange={handleChange('panel4')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4bh-content"
                        id="panel4bh-header"
                    >
                        <Typography className={classes.heading}>Model/Duty</Typography>
                        {!expanded.includes('panel4') &&
                            <Typography className={classes.secondaryHeading}>
                                Qty: {getValues('attributes.fanQty')} | Design: {getValues('attributes.fanDesign')} | Size: {getValues('attributes.fanSize')}{fanSizePlusMinus(getValues('attributes.fanSizePlusMinus'))}/{getValues('attributes.fanPercentageWidth')} | Drive: {getValues('attributes.fanDrive')} | Arrangement: {getValues('attributes.fanArrangement')} {getValues('attributes.fanOther') && `| ${getValues('attributes.fanOther')}`}
                            </Typography>
                        }
                    </AccordionSummary>
                    <AccordionDetails style={{ background: '#fff2cc', paddingTop: '20px' }}>
                        <ModelDuty control={control} />
                    </AccordionDetails>
                </Accordion>

                <br />

                <Typography variant="h4" gutterBottom>
                    Fan Data
                </Typography>
                {!showEdit ?
                    <Table control={control} setShowEdit={setShowEdit} getValues={getValues} watch={watch} attributes={jobData.attributes} /> :
                    <ContentWrapper>
                        <Motor control={control} />
                        <Impeller control={control} watch={watch} />
                        <Liners control={control} />
                        <Hub control={control} />
                        <HubBush control={control} />
                        <FanPulley control={control} />
                        <MotorPulley control={control} />
                        <Belts control={control} />
                        <BeltGuard control={control} />
                        <SlideRails control={control} />
                        <Balancing control={control} />
                        <Shaft control={control} />
                        <CoolingFin control={control} />
                        <ShaftGuard control={control} />
                        <BearingsDE control={control} />
                        <BearingsNDE control={control} />
                        <ShaftSeal control={control} />
                        <ShaftSealElementA control={control} />
                        <ShaftSealElementB control={control} />
                        <Couplings control={control} />
                        <CouplingGuard control={control} />
                        <Case control={control} />
                        <InletCone control={control} />
                        <Pedestal control={control} />
                        <Base control={control} />
                        <BaseMount control={control} />
                        <InletDamper control={control} />
                        <InletBox control={control} />
                        <InletSilencer control={control} />
                        <InletSilencerTransition control={control} />
                        <InletFlexible control={control} />
                        <InletVanes control={control} />
                        <Evase control={control} />
                        <OutletDamper control={control} />
                        <OutletSilencer control={control} />
                        <OutletSilencerTransition control={control} />
                        <OutletFlexible control={control} />
                        <Internal control={control} />
                        <External control={control} />
                        <LagClad control={control} />

                        <Grid container justify="flex-end">
                            <Button
                                variant='contained'
                                color="secondary"
                                type='submit'
                                onClick={() => setShowEdit(false)}
                            >
                                Table View
                            </Button>
                        </Grid>
                    </ContentWrapper>
                }

                <OtherOptions control={control} fields={fields} append={append} remove={remove} effectiveDueDate={effectiveDueDate} />

                <br />
                <br />

                <Accordion expanded={expanded.includes('panel5')} onChange={handleChange('panel5')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel5bh-content"
                        id="panel5bh-header"
                    >
                        <Typography className={classes.heading}>NDT</Typography>
                    </AccordionSummary>
                    <AccordionDetails style={{ background: '#d9ead3', paddingTop: '20px' }}>
                        <NDT control={control} />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expanded.includes('panel6')} onChange={handleChange('panel6')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel6bh-content"
                        id="panel6bh-header"
                    >
                        <Typography className={classes.heading}>QA</Typography>
                        <Typography className={classes.secondaryRedHeading}>
                            {qaItp === true ? 'ITP Required': ''}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails style={{ background: '#d9ead3', paddingTop: '20px' }}>
                        <QA control={control} getValues={getValues} watch={watch} />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expanded.includes('panel7')} onChange={handleChange('panel7')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel7bh-content"
                        id="panel7bh-header"
                    >
                        <Typography className={classes.heading}>Delivery</Typography>
                    </AccordionSummary>
                    <AccordionDetails style={{ background: '#d9ead3', paddingTop: '20px' }}>
                        <Delivery control={control} quoteData={quoteData} clientData={clientData} getValues={getValues} watch={watch} setValue={setValue} />
                    </AccordionDetails>
                </Accordion>

                <br />

                <Grid container justifyContent="space-between">
                    <Grid>
                        { userAttr.roles.includes("Admin") && <>
                            <Typography variant="h1" className={classes.header} style={{ display: 'inline' }}>State: </Typography>
                            <Controller
                                name='jobStateID'
                                type={'select'}
                                control={control}
                                render={({ field, fieldState: { error } }) =>
                                    <FormControl variant='outlined' className={classes.select}>
                                        <Select
                                            native
                                            {...field}
                                            margin='dense'
                                            onChange={(e) => {
                                                return field.onChange(e.target.value)
                                            }}>
                                            {jobStateList.map(({ label, id }) => {
                                                return [
                                                    <option key={`state-${id}`} value={id}>{label}</option>
                                                ]
                                            })}
                                        </Select>
                                    </FormControl>
                                }
                            />
                        </>}
                    </Grid>
                    <Grid >
                        <Button
                            variant='contained'
                            color="secondary"
                            type='button'
                            onClick={handleSaveClick}
                        >
                            Save Job Data
                        </Button>
                        &nbsp;
                        <Button
                            variant='contained'
                            color='primary'
                            type='button'
                            onClick={() => generatePDF(JobSheetPDF, 'Jobsheet')}
                        >
                            Generate Jobsheet
                        </Button>
                        &nbsp;
                        <Button
                            variant='contained'
                            color='primary'
                            type='button'
                            onClick={() => generatePDF(WarehousePDF, 'WarehouseJobsheet')}
                        >
                            Generate Warehouse Jobsheet
                        </Button>
                        &nbsp;
                        <Button
                            variant='contained'
                            color='primary'
                            type='button'
                            onClick={() => generatePDF(PaintPDF, 'FinishScope')}
                        >
                            Generate Finish Scope
                        </Button>
                    </Grid>
                </Grid>
                <br />

                <Accordion expanded={expanded.includes('panel8')} onChange={handleChange('panel8')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel8bh-content"
                        id="panel8bh-header"
                    >
                        <Typography className={classes.heading}>Files</Typography>
                    </AccordionSummary>
                    <AccordionDetails style={{ background: '#d9d2e9', paddingTop: '20px' }}>
                        <Files url={`/jobs/${jobData.id}/files`} />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expanded.includes('panel9')} onChange={handleChange('panel9')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel9bh-content"
                        id="panel9bh-header"
                    >
                        <Typography className={classes.heading}>Status Log</Typography>
                    </AccordionSummary>
                    <AccordionDetails style={{ background: '#d9d2e9', paddingTop: '20px' }}>
                        <TableContainer component={Paper}>
                            <TableMain>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ padding: '5px' }}>Date</TableCell>
                                        <TableCell style={{ padding: '5px' }}>Status</TableCell>
                                        <TableCell style={{ padding: '5px' }}>Note</TableCell>
                                        <TableCell style={{ padding: '5px' }}>User</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {jobData.jobStatusChanges.length > 0 ? jobData.jobStatusChanges.map((change, i) => (
                                        <TableRow key={i}>
                                            <TableCell style={{ padding: '5px' }}>
                                                {new Date(change.changedAt).toLocaleDateString("en-AU", { day: '2-digit', month: '2-digit', year: '2-digit' })}
                                            </TableCell>
                                            <TableCell style={{ padding: '5px' }}>{change.jobStatusName}</TableCell>
                                            <TableCell style={{ padding: '5px' }}>{change.jobStatusNotice}</TableCell>
                                            <TableCell style={{ padding: '5px' }}>{change.changedUserName}</TableCell>
                                        </TableRow>
                                    )) : null}
                                </TableBody>
                            </TableMain>
                        </TableContainer>
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expanded.includes('panel11')} onChange={handleChange('panel11')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel11bh-content"
                        id="panel11bh-header"
                    >
                        <Typography className={classes.heading}>Audit Log</Typography>
                    </AccordionSummary>
                    <AccordionDetails style={{ background: '#d9d2e9', paddingTop: '20px' }}>
                        <Grid container>
                            {changesData.length > 0 ? changesData.filter(change => Object.keys(change.change).length > 0).map((change, i) => {
                                const label = f => f.replace(/([A-Z])/g, ' $1').trim();
                                const renderField = (field, value, j) => {
                                    if (!Array.isArray(value) || value.length < 2) return null;
                                    const [oldVal, newVal] = value;
                                    return (
                                        <div key={j} style={{ fontSize: '0.85rem', margin: '2px 0' }}>
                                            <b>{label(field)}:</b>&nbsp;
                                            <span style={{ color: '#cc0000', textDecoration: 'line-through' }}>{String(oldVal ?? '')}</span>
                                            {' → '}
                                            <span style={{ color: '#006600' }}>{String(newVal ?? '')}</span>
                                        </div>
                                    );
                                };
                                return <Grid key={i} item xs={6}>
                                    <b>Date:</b> {new Date(change.changedAt).toLocaleDateString("en-AU", { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' })}<br />
                                    <b>User:</b> {change.changedUserName}<br />
                                    {Object.entries(change.change).map(([field, value], j) =>
                                        Array.isArray(value)
                                            ? renderField(field, value, j)
                                            : (value && typeof value === 'object' && value._t === 'a')
                                                ? <div key={j}><b>{label(field)}:</b><div className={classes.conflictChanges} dangerouslySetInnerHTML={{ __html: JsonDiffPatch.formatters.html.format(value) }} /></div>
                                                : (value && typeof value === 'object')
                                                    ? <div key={j}><b>{label(field)}:</b>{Object.entries(value).map(([f, v], k) => renderField(f, v, k))}</div>
                                                    : null
                                    )}
                                    <br />
                                </Grid>
                            }) : 'No job changes made or please reload to get latest data.'
                            }
                        </Grid>
                    </AccordionDetails>
                </Accordion>

                <br />
                <br />

            </form>
        </Container>
    );
};

export default Form;
